import { Component, OnInit, Output, EventEmitter, Input, ViewChild, ElementRef } from "@angular/core";
import { ScriptLoaderService } from "projects/services/src/app/script-loader.service";

@Component({
	selector: "app-time-picker",
	templateUrl: "./time-picker.component.html",
	styleUrls: ["./time-picker.component.css"]
})
export class TimePickerComponent implements OnInit {
	@ViewChild('pickTime') pickTime: ElementRef;
	@Output()
	date: EventEmitter<any> = new EventEmitter<any>();
	@Input()
	label: string;
	@Input()
	timeId: string;
	@Input()
	model: {
		placeholder1: string;
		placeholder2: string;
		disabled?: boolean;
		readonly?: boolean;
		required?: boolean;
		timeId?: string;
	} = {
		placeholder1: "Select Time",
		placeholder2: "Select Time",
		disabled: false,
		readonly: false,
		required: false,
		timeId: "m_timepicker_3_modal"
	};
	@Input()
	timePicker: TimePicker;
	dates = {
		startTime: null,
		endTime: null
	};
	showErrorMsg: boolean = false;
	constructor(private scriptLoaderService: ScriptLoaderService) {}
	time = {hour: 13, minute: 30};
	meridian = true;

	toggleMeridian() {
		this.meridian = !this.meridian;
	}
	ngOnInit() {
		this.scriptLoaderService.addScriptTagToElementDOM(
			"../assets/demo/default/custom/components/forms/widgets/bootstrap-timepicker.js"
		);
	}
	emitDateValues() {
		console.log("1111111111111111111111", this.dates);
		this.date.emit(this.dates);
	}

	onDateChange(event) {
		if (event.target.value === "" && this.model.required === true) {
			this.showErrorMsg = true;
		} else {
			this.date.emit(this.dates);
		}
	}

	onTimeChange(){
		console.log(this.pickTime.nativeElement.value);
		this.date.emit(this.pickTime.nativeElement.value)
	}

	onNgbTimeChange(event){
		console.log(this.time);
	}
}

export interface TimePicker {
	placeholder: string;
	disabled?: boolean;
	readonly?: boolean;
	required?: boolean;
	timeID: string;
	value?: any;
}
